import {defineRouting} from "next-intl/routing";
import {createNavigation} from "next-intl/navigation";
import {LocaleItem} from "@/types/contentful/locale-item";
 
export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ["en-us", "en-ca","en-au","en-nz"],
 
  // Used when no locale matches
  defaultLocale: "en-us"
});

export type Locale = (typeof routing.locales)[number];

// Centralized list of all supported locales for metadata generation
export const ALL_LOCALES: Locale[] = [...routing.locales]; // Use spread to ensure it's a separate array if needed

// Centralized Base URL for canonical/hreflang links
export const BASE_URL = process.env.NEXT_PUBLIC_SITE_URL || "https://www.gocollette.com";
 
export const localeItems: LocaleItem[] = [
    
        {
          id:"en-us",
          label:"US",
          icon:"https://i.gocollette.com/renderings/objects/page-components/header/language-selector-flags/en.svg",
          alt:"US",
          siteName:"collette-us",
          sitecoreLanguage:"en"
        },
        {
          id:"en-ca",
          label:"CA",
          icon:"https://i.gocollette.com/renderings/objects/page-components/header/language-selector-flags/en-ca.svg",
          alt:"CA",
          siteName:"collette-ca",
          sitecoreLanguage:"en-CA"
        },
        {
          id:"en-au",
          label:"AU",
          icon:"https://i.gocollette.com/renderings/objects/page-components/header/language-selector-flags/en-au.svg",
          alt:"AU",
          siteName:"collette-au",
          sitecoreLanguage:"en-AU"
        },
        {
          id:"en-nz",
          label:"NZ",
          icon:"https://i.gocollette.com/renderings/objects/page-components/header/language-selector-flags/en-za.svg",
          alt:"NZ",
          siteName:"collette-nz",
          sitecoreLanguage:"en-ZA"
        }
    
   ];
   
// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const {Link, redirect, usePathname, useRouter, getPathname} =
  createNavigation(routing);